import React from "react";
import { Controller, useForm } from "react-hook-form";
import { SocialMediaLink } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import validator from "validator";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: SocialMediaLink) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: SocialMediaLink;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<SocialMediaLink>({
    reValidateMode: "onChange",
    mode: "onSubmit",
    defaultValues: props.data,
  });

  const renderImageUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Image Url<span className="text-danger">*</span></label>
          <Controller
            key={`imageUrl-controller`}
            control={control}
            rules={{
              required: "Image Url is required",
              validate: {
                validUrl: (value) => validator.isURL(value) || "Invalid URL",
              },
            }}
            name={`imageUrl`}
            render={({ onChange, value, name }) => (
              <input
                key={`imageUrl`}
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Base Url"
                name={name}
                value={value}
                onChange={onChange}
                id={`imageUrl`}
              />
            )}
          />
          <ErrorMessage>{errors.imageUrl?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Url<span className="text-danger">*</span></label>
          <Controller
            key={`url-controller`}
            control={control}
            rules={{
              required: "Url is required",
              validate: {
                validUrl: (value) => validator.isURL(value) || "Invalid URL",
              },
            }}
            name={`url`}
            render={({ onChange, value, name }) => (
              <input
                key={`url`}
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Url"
                name={name}
                value={value}
                onChange={onChange}
                id={`url`}
              />
            )}
          />
          <ErrorMessage>{errors.url?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderName = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Name<span className="text-danger">*</span></label>
          <Controller
            key={`name-controller`}
            control={control}
            rules={{
              required: "Name is required",
            }}
            name={`name`}
            render={({ onChange, value, name }) => (
              <input
                key={`name`}
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Name"
                name={name}
                value={value}
                onChange={onChange}
                id={`name`}
              />
            )}
          />
          <ErrorMessage>{errors.name?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit(props.onSubmit)}
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            {props.data ? "Update" : "Add"}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="p-4">
      <h4 className="mb-3 font-weight-semibold">
        {props.data ? "Update" : "Add"} Social Media
      </h4>
      <div className="row gutter-10">
        {renderName()}
        {renderUrl()}
        {renderImageUrl()}
        <ErrorMessage>{props.error}</ErrorMessage>
        {renderButton()}
      </div>
    </div>
  );
};

export default UpdateForm;
